import * as RadixCheckbox from '../checkbox'
import { CheckIcon } from '../icons'
import { tw } from 'utils/classnames'

export function Checkbox({
  label,
  checked,
  onClick,
  value,
  className,
  labelClassname,
  checkboxClassname,
  idSuffix,
  isError,
}: {
  label: React.ReactNode
  value: string
  checked: boolean
  onClick: () => void
  className?: string
  labelClassname?: string
  checkboxClassname?: string
  idSuffix?: string
  isError?: boolean
}) {
  const identifier = `cf-checkbox-${value}${idSuffix ? `-${idSuffix}` : ''}`
  return (
    <div className={tw('flex items-start gap-2 pb-[4px] pt-[5px]', className)}>
      <RadixCheckbox.Root
        className={tw(
          checked ? 'border-aubergine-500' : 'border-[#9895A5]',
          'mt-[5px] size-[15px] shrink-0 border-2 outline-0',
          isError ? 'border-red-100' : '',
          checkboxClassname,
        )}
        onCheckedChange={onClick}
        id={identifier}
        checked={checked}
      >
        <RadixCheckbox.Indicator className="">
          <CheckIcon className={tw(checked ? 'text-aubergine-500' : '', 'size-[11px]')} />
        </RadixCheckbox.Indicator>
      </RadixCheckbox.Root>
      <label className={labelClassname} htmlFor={identifier}>
        {label}
      </label>
    </div>
  )
}
